import { useEffect, useRef } from "react";

export const didLoadingClose = (wasOpen, isOpen) =>
  Boolean(wasOpen && !isOpen);

export default function useLoadingClosed(isOpen, onClosed) {
  const wasOpenRef = useRef(false);
  const shouldRender = Boolean(isOpen);

  useEffect(() => {
    const wasOpen = wasOpenRef.current;
    wasOpenRef.current = shouldRender;

    // Los efectos se ejecutan luego del commit, cuando el modal y su backdrop
    // ya fueron desmontados del DOM.
    if (didLoadingClose(wasOpen, shouldRender) && typeof onClosed === "function") {
      onClosed();
    }
  }, [onClosed, shouldRender]);

  return shouldRender;
}
